import { render, staticRenderFns } from "./faturalibiletduzenle.vue?vue&type=template&id=138f493e&"
import script from "./faturalibiletduzenle.vue?vue&type=script&lang=js&"
export * from "./faturalibiletduzenle.vue?vue&type=script&lang=js&"
import style0 from "./faturalibiletduzenle.vue?vue&type=style&index=0&id=138f493e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports